import { Component, OnInit,  } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup,  Validators } from '@angular/forms';
import { AccountService } from '@app/_services/account.service';
import { AlertService } from '@app/_services/alert.service';
import { ConfigDataService } from '@app/_services/config-data.service'
import { MakeModel } from '@app/_models/makeModel';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { StateCity } from '@app/_models/stateCity';
import { PlanDetails } from '@app/_models/planDetails';
import { User } from '@app/_models';
import { DealerService } from '@app/_services/dealer-service';
import { Dealer } from '@app/_models/dealer';
import { Certificate } from '@app/_models/certificate';
import { CertificateService } from '@app/_services/certificate.service'
import { CertificateCacheService } from '@app/_services/certificate-cache.service';
import { FileService } from '@app/_services/file.service';
import { first } from 'rxjs/internal/operators/first';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DealerModelConfig } from '@app/_models/dealerModelConfig';
import { DealerModelPrice } from '@app/_models/dealerModelPrice';


@Component({
  selector: 'app-edit-certificate',
  templateUrl: './edit-certificate.component.html',
  styleUrls: ['./edit-certificate.component.less']
})
export class EditCertificateComponent implements OnInit {
  certficateForm: UntypedFormGroup;
  rejectEndorsementForm: UntypedFormGroup;
  certificate: Certificate;
  showGstAmount = true;
  loading = false;
  ageOrDobValue = ["dob","age"];
  isBalanceLow = false;
  submitted = false;
  dealer = new Dealer();
  makeModel: MakeModel[];
  configMakeModel: MakeModel[];
  models: string[];
  cities: string[];
  stateCity: StateCity[];
  plans: PlanDetails[];
  maxAmount = 99999;
  minAmount = 0;
  selectedMakeModel: MakeModel;
  selectedPlan: PlanDetails;
  startDateModel: NgbDateStruct;
  dobString: string;
  customerDob: string;
  runningBalance: number;
  types = ["New", "Old"];
  genders = ["Male", "Female","NA"];
  clientTypes = ["Individual", "Corporate"];
  years: number[];
  relationships = ["Spouse","Husband","Wife", "Father", "Mother", "Son", "Daughter", "Brother", "Sister","Grandson","Granddaughter", "Other"];
  registrtionNumberValidation = [];
  certificateResponse: Certificate;
  planAmount: any;
  user: User;
  gSTAmount: number;
  gstPercentage = 0.18;
  isCorporate = true;
  User: User;
  planGSTAmount: any;
  planTotalAmount: any;
  currentDate = new Date();
  certificateCreated = false;
  issueDateString: string;
  issueDate = new Date();
  startDate = new Date();
  endDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  minDobDate = new Date(new Date().setFullYear(new Date().getFullYear() - 70));
  maxDobDate = new Date(new Date().setFullYear(new Date().getFullYear() - 15));
  minDobDateModel =  {"year":2010, "month": 1,"day": 1};
  maxDobDateModel =  {"year":2010, "month": 1,"day": 1};
  newYears = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1];
  dealarConfigFound: boolean = false;
  dealerConfig: DealerModelConfig;
  selectDealerModelPrice: DealerModelPrice;
  allDealerConfig: DealerModelConfig[] =[];

  endorseRequest: boolean;

  // Aadhar card properties
  aadharCardFile: File | null = null;
  aadharCardUrl: string | null = null;
  aadharCardRequired: boolean = false;
  aadharCardPreview: string | null = null;
  aadharCardUploading: boolean = false;
  maxFileSize = 5 * 1024 * 1024; // 5MB

  // Endorsement day-based validation properties
  daysSinceIssue: number = 0;
  endorsementBlocked: boolean = false;
  endorsementBlockedMessage: string = '';
  aadharRequiredByAdmin: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private accountService: AccountService,
    private alertService: AlertService,
    private configDataService: ConfigDataService,
    private dealerService: DealerService,
    private certificateService: CertificateService,
    private cacheService: CertificateCacheService,
    private fileService: FileService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,

  ) {

  }

  ngOnInit(): void {
    this.endorseRequest = this.router.url.includes('endorseRequest');
    this.certificate = this.certificateService.PrintCertificate;
    this.certificateResponse = this.certificateService.PrintCertificate;
    
    // Treat rejected endorsements as endorseRequest to show old requested changes
    if (this.certificate.certificateStatus == 'Endorsement Rejected - Pending Resubmission') {
      this.endorseRequest = true;
    }

    this.startDateModel =  {"year":2010, "month": 1,"day": 1};
    
    // For rejected endorsements, use endorseRequestCert data if available for DOB
    const certForDob = (this.certificate.certificateStatus == 'Endorsement Rejected - Pending Resubmission' && this.certificate.endorseRequestCert?.dob) 
      ? this.certificate.endorseRequestCert 
      : this.certificate;
    
    if(certForDob.ageOrDob && certForDob.ageOrDob == "age")
    {
      this.startDateModel =  {"year":2010, "month": 1,"day": 1};
    }
    else if(certForDob.dob && certForDob.dob != "NA")
    {
    this.startDateModel.year = parseInt(certForDob.dob.split('-')[0]);
    this.startDateModel.day = parseInt(certForDob.dob.split('-')[2]);
    this.startDateModel.month = parseInt(certForDob.dob.split('-')[1]);
  }

    this.minDobDateModel.year = this.minDobDate.getFullYear();
    this.minDobDateModel.day = this.minDobDate.getDate();
    this.minDobDateModel.month = this.minDobDate.getMonth() + 1;

    this.maxDobDateModel.year = this.maxDobDate.getFullYear();
    this.maxDobDateModel.day = this.maxDobDate.getDate();
    this.maxDobDateModel.month = this.maxDobDate.getMonth() + 1;

    this.configDataService.StateCity$.subscribe((x) => {
      if (x.find(a => a.state == this.certificate.state))
      {
        if(this.certificate.city && x.find(a => a.state == this.certificate.state).city.includes(this.certificate.city))
        {
          this.stateCity = x;
        }
        else
        {
          x.find(a => a.state == this.certificate.state).city.push(this.certificate.city);
        }
      }
      else
      {
        x.push({state: this.certificate.state, city: [this.certificate.city]});
      }
      this.stateCity = x;
    });
    this.configDataService.MakeModel$.subscribe((x)=>{
      this.configMakeModel = x;
    }
    );


    this.user = this.accountService.userValue;
    
    // Get notification email from endorsement request history
    let prepopulatedEmail = '';
    if (this.certificate && this.certificate.requestHistory && this.certificate.requestHistory.length > 0) {
      // Find the last "Endorsement Request" entry
      const endorsementRequests = this.certificate.requestHistory.filter(x => x.requestType === 'Endorsement Request');
      if (endorsementRequests.length > 0) {
        const lastRequest = endorsementRequests[endorsementRequests.length - 1];
        prepopulatedEmail = lastRequest.notificationEmail || '';
      }
    }
    // If not found in request history, try to get from certificate notificationEmail
    if (!prepopulatedEmail && this.certificate && this.certificate.notificationEmail) {
      prepopulatedEmail = this.certificate.notificationEmail;
    }
    // Also check endorseRequestCert if available
    if (!prepopulatedEmail && this.certificate && this.certificate.endorseRequestCert && this.certificate.endorseRequestCert.notificationEmail) {
      prepopulatedEmail = this.certificate.endorseRequestCert.notificationEmail;
    }
    
    this.rejectEndorsementForm = this.formBuilder.group({
      rejectComments: ['', Validators.required],
      notificationEmail: [prepopulatedEmail, [Validators.email, Validators.required]],
      requireAadhaar: [false]
    });
    this.certficateForm = this.formBuilder.group({
      vehicleMake: ['', Validators.required],
      model: ['', Validators.required],
      type: ['', Validators.required],
      variant: [''],
      vehicleYear: [''],
      registrationNumber: [''],
      chasisNumber: ['', Validators.required],
      engineNumber: ['', Validators.required],
      clientType:['',Validators.required],
      firstName: ['', Validators.required],
      middleName: [''],
      lastName: [''],
      email: [''],
      contactNumber: ['', [Validators.required, Validators.minLength(6)]],
      employeeContactNumber: ['', [Validators.required, Validators.minLength(6)]],
      gender: ['', Validators.required],
      dob: [this.startDateModel, Validators.required],
      ageOrDob: [this.ageOrDobValue[0]],
      age: ['', [Validators.required, Validators.min(15),Validators.max(80)]],
      gstin: [''],
      address: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      nomineeName: ['', Validators.required],
      nomineeRelationship: ['', Validators.required],
      nomineeGender: ['', Validators.required],
      nomineeAge: ['', [Validators.required, Validators.min(1),Validators.max(100)]],
      planId: ['', Validators.required],
      planAmount: ['']
      , planGSTAmount: ['']
      , planTotalAmount: ['', [Validators.required,
      (control: AbstractControl) => Validators.max(this.maxAmount)(control)
        , (control: AbstractControl) => Validators.min(this.minAmount)(control)]]
      , startDate: ['', Validators.required]
      , endDate: ['']
      , issueDate: ['']
      , balance: ['']
      , userId: ['']
      , certificateNumber: ['']
      , policyNumber: ['']
      , endorsementReason: ['']
      , endorsementCount: ['']
      ,vehicleType:['Two Wheeler']
      ,notificationEmail:['',[Validators.email,Validators.required]]
    });

    if (this.endorseRequest){
      this.certficateForm.controls['notificationEmail'].setValidators([Validators.required,Validators.email]);
      this.certficateForm.controls['notificationEmail'].updateValueAndValidity();
      
      // For rejected endorsements, show the previously requested changes (endorseRequestCert)
      if (this.certificate.certificateStatus == 'Endorsement Rejected - Pending Resubmission' && this.certificate.endorseRequestCert?.vehicleMake) {
        this.certficateForm.patchValue(new Certificate(this.certificate.endorseRequestCert));
        // Set notification email from endorseRequestCert if available
        if (this.certificate.endorseRequestCert.notificationEmail) {
          this.certficateForm.controls['notificationEmail'].setValue(this.certificate.endorseRequestCert.notificationEmail);
        }
      } else {
        this.certficateForm.patchValue(this.certificate);
      }
    }
    else
    {
      this.certficateForm.controls['notificationEmail'].clearValidators();
      this.certficateForm.controls['notificationEmail'].updateValueAndValidity();
      if (this.certificate.endorseRequestCert?.vehicleMake){
        this.certficateForm.patchValue(new Certificate(this.certificate.endorseRequestCert));
        // Update reject form email from endorseRequestCert if available
        if (this.certificate.endorseRequestCert.notificationEmail) {
          this.rejectEndorsementForm.controls['notificationEmail'].setValue(this.certificate.endorseRequestCert.notificationEmail);
        }
      }
      else
      {
        this.certficateForm.patchValue(this.certificate);
        // Update reject form email from certificate if available and not already set
        if (this.certificate.notificationEmail && !this.rejectEndorsementForm.controls['notificationEmail'].value) {
          this.rejectEndorsementForm.controls['notificationEmail'].setValue(this.certificate.notificationEmail);
        }
      }
    }
    this.certficateForm.controls['planAmount'].disable();
    this.certficateForm.controls['planGSTAmount'].disable();
    this.certficateForm.controls['planTotalAmount'].disable();
    // this.certficateForm.controls['startDate'].disable();
    this.certficateForm.controls['endDate'].disable();
    this.certficateForm.controls['issueDate'].disable();
    this.certficateForm.controls['balance'].disable();
    this.configDataService.getDealerModelConfig(this.user.dealerId).pipe(first()).subscribe({
      next: (x) => {
        this.allDealerConfig = x;
        this.dealarConfigFound = false;

      this.dealerService.getByDealerId(this.certificate.dealerId).subscribe(async (x) => {
        this.dealer = x;
        this.makeModel = x.dealerMake;
        if (this.dealerConfig && this.dealerConfig.dealerModelPrices.length > 0) {
          this.dealarConfigFound = true;
          this.getMakeModelFromDealerConfig();
        } else {
          this.dealarConfigFound = false;
          await this.setDefaultMakeModel();
        }
        // For rejected endorsements, use endorseRequestCert if available, otherwise use original certificate
        const certDataToUse = (this.certificate.certificateStatus == 'Endorsement Rejected - Pending Resubmission' && this.certificate.endorseRequestCert?.vehicleMake)
          ? this.certificate.endorseRequestCert
          : (this.certificate.endorseRequestCert?.vehicleMake ? this.certificate.endorseRequestCert : this.certificate);
        
        if (certDataToUse.vehicleMake || this.certificate.endorseRequestCert?.vehicleMake)
          {
            const dataToUse = certDataToUse.vehicleMake ? certDataToUse : this.certificate.endorseRequestCert;
            this.certficateForm.controls['vehicleMake'].setValue(dataToUse.vehicleMake);
            this.certficateForm.controls['type'].setValue(dataToUse.type);
            this.certficateForm.controls['gender'].setValue(dataToUse.gender);
            this.certficateForm.controls['nomineeGender'].setValue(dataToUse.nomineeGender);
            this.certficateForm.controls['nomineeRelationship'].setValue(dataToUse.nomineeRelationship);
            this.certficateForm.controls['state'].setValue(dataToUse.state);
            this.certficateForm.controls['clientType'].setValue(dataToUse.clientType);
    
          }
          else
          {
            this.certficateForm.controls['vehicleMake'].setValue(this.certificate.vehicleMake);
            this.certficateForm.controls['type'].setValue(this.certificate.type);
            this.certficateForm.controls['gender'].setValue(this.certificate.gender);
            this.certficateForm.controls['nomineeGender'].setValue(this.certificate.nomineeGender);
            this.certficateForm.controls['nomineeRelationship'].setValue(this.certificate.nomineeRelationship);
            this.certficateForm.controls['state'].setValue(this.certificate.state);
            this.certficateForm.controls['clientType'].setValue(this.certificate.clientType);
    
          }
        this.certficateForm.controls['balance'].setValue(this.dealer.dealerBalance);

      }
      );
    },
    error: async error => {
      // this.alertService.error(error);
      this.allDealerConfig = [];
      this.certficateForm.controls['type'].setValue(this.types[0]);
      await this.setDefaultMakeModel()
    
      // this.setDefaultMakeModel();
    }});

      // this.plans = this.user.dealerPlan;
      // this.makeModel = this.user.dealerMake;

    this.certficateForm.controls['userId'].setValue(this.user.id);
    this.certficateForm.get('planAmount').disable;

    this.certficateForm.get('clientType').valueChanges
    .subscribe(value => {
      if (value == "Individual")
      {
        this.isCorporate = false;
        // this.certficateForm.controls['nomineeGender'].setValue(this.genders[1]);
        this.certficateForm.get('gender').setValidators(Validators.required);
        this.certficateForm.get('dob').setValidators(Validators.required);
        this.certficateForm.get('nomineeRelationship').setValidators(Validators.required);
        this.certficateForm.get('employeeContactNumber').clearValidators();        
        this.plans = this.dealer.dealerPlan;
      }
      else
      {
        this.isCorporate = true;
        // this.certficateForm.controls['nomineeGender'].setValue(this.genders[0]);
        this.certficateForm.get('gender').clearValidators();
        this.certficateForm.get('dob').clearValidators();
        this.certficateForm.get('nomineeRelationship').clearValidators();
        this.certficateForm.get('employeeContactNumber').setValidators([Validators.required, Validators.minLength(6)]);
        this.plans = this.dealer.dealerPlan.filter(x => x.policyType.includes("RSA") || x.policyType.includes("DOC"));

      }
      this.certficateForm.controls['gender'].updateValueAndValidity();
      this.certficateForm.controls['dob'].updateValueAndValidity();
      this.certficateForm.controls['nomineeRelationship'].updateValueAndValidity();
      this.certficateForm.controls['employeeContactNumber'].updateValueAndValidity();
    });
    this.certficateForm.controls['dob'].setValue(this.startDateModel);

    this.certficateForm.get('model').valueChanges
      .subscribe(value => {
        if (value == "Others") {
          this.certficateForm.get('variant').setValidators(Validators.required);
        }
        else {
          this.certficateForm.get('variant').clearValidators();
        }
        this.certficateForm.controls['variant'].updateValueAndValidity();
      });

    this.certficateForm.get('type').valueChanges
      .subscribe(value => {
        if (value == "Old") {
          // this.certficateForm.controls['vehicleYear'].setValue(this.currentDate.getFullYear());
          this.certficateForm.get('registrationNumber').setValidators(Validators.required);
          this.years = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1
            , this.currentDate.getFullYear() - 2
            , this.currentDate.getFullYear() - 3
            , this.currentDate.getFullYear() - 4
            , this.currentDate.getFullYear() - 5
            , this.currentDate.getFullYear() - 6
            , this.currentDate.getFullYear() - 7
            , this.currentDate.getFullYear() - 8
            , this.currentDate.getFullYear() - 9
            , this.currentDate.getFullYear() - 10
            , this.currentDate.getFullYear() - 11
            , this.currentDate.getFullYear() - 12
            , this.currentDate.getFullYear() - 13
            , this.currentDate.getFullYear() - 14
          ];
          this.certficateForm.controls['startDate'].enable();
        }

        else {
          this.years = [this.currentDate.getFullYear(), this.currentDate.getFullYear() - 1, this.currentDate.getFullYear() - 2];
          this.certficateForm.get('registrationNumber').clearValidators();
          this.certficateForm.controls['startDate'].disable();
        }
        this.certficateForm.controls['registrationNumber'].updateValueAndValidity();
        this.certficateForm.controls['startDate'].updateValueAndValidity();
        //  this.certficateForm.controls['vehicleYear'].setValue(this.years[0]);
      });



    this.certficateForm.get('state').valueChanges.subscribe((value) => {
      if (value != undefined) {
        this.cities = this.stateCity.filter((x) => x.state == value)[0].city;
      }
    })
    this.certficateForm.get('vehicleMake').valueChanges.subscribe((value) => {
      if (value != undefined) {
        if (this.makeModel)
          {
            this.selectedMakeModel = this.makeModel.find(a => a.make == value);
            if (this.selectedMakeModel)
            {
              this.certficateForm.controls['vehicleType'].setValue(this.selectedMakeModel.productType?this.selectedMakeModel.productType:"Two Wheeler");
              this.models =  this.selectedMakeModel.model;
            }
            else
            {
              this.certficateForm.controls['vehicleType'].setValue("Two Wheeler");
              this.models =  ["Others",this.certificate.model];
            }
          }
          else
          {
        this.configDataService.MakeModel$.subscribe(
          (x) => {this.selectedMakeModel = x.find(a => a.make == value);
          if (this.selectedMakeModel)
            {
              this.certficateForm.controls['vehicleType'].setValue(this.selectedMakeModel.productType?this.selectedMakeModel.productType:"Two Wheeler");
              this.models =  this.selectedMakeModel.model;
            }
            else
            {
              this.certficateForm.controls['vehicleType'].setValue("Two Wheeler");
              this.models =  ["Others",this.certificate.model];

            }
          }
        )
      }
    }
    })

    this.certficateForm.get('dob').valueChanges.subscribe((value) => {
      if (value != undefined) {
        this.customerDob = value.year + "-" + ('0' + (value.month)).slice(-2)+  "-" + ('0' + (value.day)).slice(-2)  ;
      }
      this.checkIfAadharRequired();
    })

    // Monitor demographic field changes
    this.certficateForm.get('firstName')?.valueChanges.subscribe(() => this.checkIfAadharRequired());
    this.certficateForm.get('lastName')?.valueChanges.subscribe(() => this.checkIfAadharRequired());
    this.certficateForm.get('gender')?.valueChanges.subscribe(() => this.checkIfAadharRequired());
    this.certficateForm.get('age')?.valueChanges.subscribe(() => this.checkIfAadharRequired());
    this.certficateForm.get('ageOrDob')?.valueChanges.subscribe(() => this.checkIfAadharRequired());

    // Load existing Aadhar card URL if available (check both certificate and endorseRequestCert)
    if (this.certificate?.aadharCardUrl) {
      this.aadharCardUrl = this.certificate.aadharCardUrl;
    } else if (this.certificate?.endorseRequestCert?.aadharCardUrl) {
      this.aadharCardUrl = this.certificate.endorseRequestCert.aadharCardUrl;
    }

    // Calculate days since issue date and check endorsement eligibility
    this.calculateDaysSinceIssue();
    this.checkIfAadharRequiredByAdmin();
    this.checkEndorsementEligibility();

    // Check if Aadhar is required on initialization
    this.checkIfAadharRequired();

  }


  get f() { return this.certficateForm.controls; }
  get rejectF() { return this.rejectEndorsementForm.controls; }

  /**
   * Handle Aadhaar requirement checkbox change
   * Auto-populate rejection comments when checked
   */
  onRequireAadhaarChange(): void {
    const requireAadhaar = this.rejectF.requireAadhaar.value;
    let currentComments = this.rejectF.rejectComments.value || '';
    
    const aadharMessage = 'To complete this endorsement, please provide a copy of your Aadhaar card for verification purposes. This helps us maintain accurate customer records.';
    
    if (requireAadhaar) {
      // Checkbox is checked - add the message if not already present
      if (!currentComments.includes(aadharMessage)) {
        if (currentComments.trim()) {
          currentComments += '\n\n' + aadharMessage;
        } else {
          currentComments = aadharMessage;
        }
        this.rejectF.rejectComments.setValue(currentComments);
      }
    } else {
      // Checkbox is unchecked - remove the message if present
      currentComments = currentComments.replace('\n\n' + aadharMessage, '').replace(aadharMessage, '').trim();
      this.rejectF.rejectComments.setValue(currentComments);
    }
  }

  // Helper method to convert age to DOB (1st Jan of currentDate - age year)
  convertAgeToDob(age: number): string {
    if (!age) return null;
    const currentDate = new Date();
    const dobYear = currentDate.getFullYear() - age;
    return dobYear + "-01-01";
  }

  // Helper method to get DOB value from certificate (converting age if needed)
  getDobValue(cert: Certificate, ageOrDob: string): string {
    if (!ageOrDob) ageOrDob = "dob";
    if (ageOrDob == "age" && cert.age) {
      return this.convertAgeToDob(cert.age);
    }
    return cert.dob || null;
  }

  // Get the original certificate (for old values)
  getOriginalCertificate(): Certificate {
    return this.certificate;
  }

  // Get the requested certificate (for new values when approver)
  getRequestedCertificate(): Certificate {
    return this.certificate?.endorseRequestCert || null;
  }

  // Get old DOB value for display
  getOldDobValue(): string {
    if (!this.certificate) return null;
    return this.getDobValue(this.certificate, this.certificate.ageOrDob);
  }

  // Get new DOB value for display
  getNewDobValue(): string {
    // For approver view, use endorseRequestCert if available
    if (!this.endorseRequest && this.certificate?.endorseRequestCert) {
      const requestedCert = this.certificate.endorseRequestCert;
      return this.getDobValue(requestedCert, requestedCert.ageOrDob);
    }
    
    // For requestor view, use form values
    const ageOrDob = this.certficateForm.get('ageOrDob')?.value || "dob";
    if (ageOrDob == "age") {
      const age = this.certficateForm.get('age')?.value;
      if (age) {
        return this.convertAgeToDob(age);
      }
    } else {
      const dobValue = this.certficateForm.get('dob')?.value;
      if (dobValue && dobValue.year) {
        return dobValue.year + "-" + ('0' + dobValue.month).slice(-2) + "-" + ('0' + dobValue.day).slice(-2);
      }
    }
    return null;
  }

  // Normalize value for comparison (trim strings, handle null/undefined)
  private normalizeValue(value: any): any {
    if (value === null || value === undefined) {
      return null;
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      return trimmed === '' ? null : trimmed;
    }
    if (typeof value === 'number') {
      return isNaN(value) ? null : value;
    }
    return value;
  }

  // Check if a field value has changed (strict comparison)
  hasFieldChanged(fieldName: string): boolean {
    // For approver view, compare original certificate with endorseRequestCert
    if (!this.endorseRequest && this.certificate?.endorseRequestCert) {
      const oldValue = this.normalizeValue(this.certificate[fieldName]);
      const newValue = this.normalizeValue(this.certificate.endorseRequestCert[fieldName]);
      
      // If both are null/undefined, no change
      if (oldValue === null && newValue === null) {
        return false;
      }
      
      // Strict comparison - values must be different
      return oldValue !== newValue;
    }
    
    // For requestor view, compare certificate with form value
    const formValue = this.normalizeValue(this.certficateForm.get(fieldName)?.value);
    const certValue = this.normalizeValue(this.certificate[fieldName]);
    
    // If both are null/undefined, no change
    if (formValue === null && certValue === null) {
      return false;
    }
    
    // Strict comparison - values must be different
    return formValue !== certValue;
  }

  // Get old value for a field
  getOldValue(fieldName: string): any {
    return this.certificate[fieldName] || 'N/A';
  }

  // Get new value for a field
  getNewValue(fieldName: string): any {
    // For approver view, use endorseRequestCert
    if (!this.endorseRequest && this.certificate?.endorseRequestCert) {
      return this.certificate.endorseRequestCert[fieldName] || 'N/A';
    }
    
    // For requestor view, use form value
    return this.certficateForm.get(fieldName)?.value || 'N/A';
  }

  // Check if DOB has changed (strict comparison)
  hasDobChanged(): boolean {
    const oldDob = this.normalizeValue(this.getOldDobValue());
    const newDob = this.normalizeValue(this.getNewDobValue());
    
    // If both are null/undefined, no change
    if (oldDob === null && newDob === null) {
      return false;
    }
    
    // Strict comparison - values must be different
    return oldDob !== newDob;
  }

  // Calculate days since issue date
  calculateDaysSinceIssue(): void {
    if (!this.certificate?.issueDate) {
      this.daysSinceIssue = 0;
      return;
    }

    const issueDate = new Date(this.certificate.issueDate);
    const today = new Date();
    
    // Reset time part for accurate day calculation
    issueDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    const timeDiff = today.getTime() - issueDate.getTime();
    this.daysSinceIssue = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  }

  // Check if admin rejected endorsement requesting Aadhaar
  checkIfAadharRequiredByAdmin(): void {
    this.aadharRequiredByAdmin = false;
    
    if (!this.certificate?.requestHistory || this.certificate.requestHistory.length === 0) {
      return;
    }

    // Check if the last rejection mentioned Aadhaar requirement
    const rejections = this.certificate.requestHistory.filter(
      x => x.requestType === 'Endorsement Rejected' || x.requestType === 'Rejection'
    );

    if (rejections.length > 0) {
      const lastRejection = rejections[rejections.length - 1];
      const comment = (lastRejection.comment || '').toLowerCase();
      
      // Check if rejection comment mentions Aadhaar/Aadhar requirement
      if (comment.includes('aadhar') || comment.includes('aadhaar') || comment.includes('uidai') || comment.includes('id proof')) {
        this.aadharRequiredByAdmin = true;
      }
    }
  }

  // Check endorsement eligibility based on days since issue
  checkEndorsementEligibility(): void {
    this.endorsementBlocked = false;
    this.endorsementBlockedMessage = '';

    // If more than 30 days, block endorsement for non-admin users only
    if (this.daysSinceIssue > 30 && this.user.role !== 'admin') {
      this.endorsementBlocked = true;
      this.endorsementBlockedMessage = 'Endorsement is not allowed after 30 days from issue date. Please contact support@allianceassure.in for assistance with your endorsement request.';
    }
  }

  // Check if Aadhar card is required based on demographic field changes and days since issue
  checkIfAadharRequired(): void {
    if (!this.certificate) {
      this.aadharCardRequired = false;
      return;
    }

    // Check if any demographic field has changed
    const firstNameChanged = this.hasFieldChanged('firstName');
    const lastNameChanged = this.hasFieldChanged('lastName');
    const genderChanged = this.hasFieldChanged('gender');
    const dobChanged = this.hasDobChanged();
    const demographicChanged = firstNameChanged || lastNameChanged || genderChanged || dobChanged;

    // Aadhaar requirement logic based on days since issue:
    // Same day (0 days): No Aadhaar needed
    // 1-15 days: Aadhaar NOT mandatory unless admin rejected requesting Aadhaar
    // 16-30 days: Aadhaar mandatory for demographic change
    // More than 30 days: Endorsement blocked (handled separately)

    if (this.daysSinceIssue === 0) {
      // Same day - no Aadhaar required
      this.aadharCardRequired = false;
    } else if (this.daysSinceIssue >= 1 && this.daysSinceIssue <= 15) {
      // 1-15 days - Aadhaar only required if admin rejected requesting Aadhaar
      this.aadharCardRequired = demographicChanged && this.aadharRequiredByAdmin;
    } else if (this.daysSinceIssue >= 16 && this.daysSinceIssue <= 30) {
      // 16-30 days - Aadhaar mandatory for demographic change
      this.aadharCardRequired = demographicChanged;
    } else {
      // More than 30 days - endorsement blocked, Aadhaar requirement doesn't matter
      this.aadharCardRequired = false;
    }
  }

  // Handle Aadhar card file selection
  onAadharFileSelected(event: any): void {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    // Validate file type - allow images and PDF
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) {
      this.alertService.error('Invalid file type. Please upload a JPG, JPEG, PNG image or PDF file.');
      event.target.value = '';
      return;
    }

    // Validate file size
    if (file.size > this.maxFileSize) {
      this.alertService.error('File size exceeds 5MB. Please upload a smaller file.');
      event.target.value = '';
      return;
    }

    this.aadharCardFile = file;

    // Create preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.aadharCardPreview = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  // Upload Aadhar card file
  uploadAadharCard(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!this.aadharCardFile || !this.certificate?.certificateNumber) {
        reject('File or certificate number missing');
        return;
      }

      this.aadharCardUploading = true;
      this.fileService.uploadAadharCard(this.aadharCardFile, this.certificate.certificateNumber)
        .pipe(first())
        .subscribe({
          next: (response: any) => {
            this.aadharCardUploading = false;
            if (response && response.url) {
              this.aadharCardUrl = response.url;
              this.alertService.success('Aadhar card uploaded successfully');
              resolve(response.url);
            } else {
              reject('Upload failed: Invalid response');
            }
          },
          error: (error) => {
            this.aadharCardUploading = false;
            this.alertService.error('Failed to upload Aadhar card: ' + (error.error || error.message || 'Unknown error'));
            reject(error);
          }
        });
    });
  }

  // Download Aadhar card
  downloadAadharCard(): void {
    if (!this.aadharCardUrl) {
      this.alertService.error('Aadhar card URL not available');
      return;
    }

    this.fileService.downloadAadharCard(this.aadharCardUrl)
      .pipe(first())
      .subscribe({
        next: (blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${this.certificate.certificateNumber}-aadhar.jpg`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
        error: (error) => {
          this.alertService.error('Failed to download Aadhar card: ' + (error.error || error.message || 'Unknown error'));
        }
      });
  }

  // Remove selected Aadhar card file
  removeAadharCard(): void {
    this.aadharCardFile = null;
    this.aadharCardPreview = null;
    // Note: We don't clear aadharCardUrl here as it might be an existing uploaded file
  }

  // Get Aadhar card image URL for display
  getAadharCardImageUrl(fileName: string): string {
    if (!fileName) return '';
    return this.fileService.getAadharCardImageUrl(fileName);
  }

  getMakeModelFromDealerConfig() {
    this.makeModel = [...new Set(this.dealerConfig.dealerModelPrices.map(a => a.make))].map(a=> {
      return {
        make: a
      , model: [...new Set(this.dealerConfig.dealerModelPrices.filter(b => b.make == a).map(r=> r.model))]
      , productType: "Two Wheeler"
    }});
  }
  async setDefaultMakeModel(){
    this.configDataService.MakeModel$.subscribe(x => {
      this.makeModel = x;
    })
  }


  async onEndorseClick() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // Check if endorsement is blocked (more than 30 days from issue date)
    if (this.endorsementBlocked) {
      this.alertService.error(this.endorsementBlockedMessage);
      return;
    }
    
    // Calculate age from dob if age is not received (before validation)
    if (!this.isCorporate) {
      const ageControl = this.certficateForm.get('age');
      const ageValue = ageControl?.value;
      const dobValue = this.certficateForm.get('dob')?.value;
      
      if ((!ageValue || ageValue === '' || ageValue === 0 || (typeof ageValue === 'string' && !ageValue)) && dobValue) {
        const calculatedAge = this.calculateAgeFromDob(dobValue);
        if (calculatedAge > 0) {
          ageControl?.setValue(calculatedAge);
          ageControl?.updateValueAndValidity();
        }
      }
    }

    // Re-check for admin-requested Aadhaar requirement (in case of rejection resubmission)
    this.checkIfAadharRequiredByAdmin();
    
    // Check if Aadhar card is required
    this.checkIfAadharRequired();
    
    // Validate Aadhar card requirement (for non-admin users)
    if (this.aadharCardRequired && this.user.role !== 'admin') {
      if (!this.aadharCardUrl && !this.aadharCardFile) {
        // Provide specific error message based on the reason
        if (this.aadharRequiredByAdmin && this.daysSinceIssue >= 1 && this.daysSinceIssue <= 15) {
          this.alertService.error('As per admin request, Aadhaar card upload is required to complete this endorsement');
        } else if (this.daysSinceIssue >= 16 && this.daysSinceIssue <= 30) {
          this.alertService.error('Aadhar card upload is mandatory when customer demographic information changes');
        } else {
          this.alertService.error('Aadhar card upload is mandatory when customer demographic information changes');
        }
        return;
      }
    }
    
    // Upload Aadhar card if file is selected but not yet uploaded
    if (this.aadharCardFile && !this.aadharCardUrl) {
      try {
        this.loading = true;
        await this.uploadAadharCard();
      } catch (error) {
        this.loading = false;
        return; // Stop if upload fails
      }
    }
    
    // stop here if form is invalid
    if (this.certficateForm.invalid) {
      const invalidFields: string[] = [];
      Object.keys(this.certficateForm.controls).forEach(key => {
        const control = this.certficateForm.get(key);
        if (control && control.invalid) {
          invalidFields.push(key);
        }
      });
      console.log('Invalid form fields:', invalidFields);
      this.loading = false;
      return;
    }
    this.loading = true;
    var issueCertificate: Certificate;
    issueCertificate = new Certificate(this.certficateForm.value);
    issueCertificate.certificateNumber = this.certificate.certificateNumber;
    // Set Aadhar card URL if available
    if (this.aadharCardUrl) {
      issueCertificate.aadharCardUrl = this.aadharCardUrl;
    }
    if (!issueCertificate.email)
        issueCertificate.email = " ";
    
    if (this.isCorporate)
    { 
      issueCertificate.gender = "Organisation"
      issueCertificate.dob = "NA"
      issueCertificate.nomineeRelationship = "NA"   
    }
    else{
      issueCertificate.employeeContactNumber = "NA";
      this.customerDob  = this.convertTextDate(this.certficateForm.get('dob').value);
      issueCertificate.dob = this.customerDob;
      
      // Calculate age from dob if age is not received
      if (!issueCertificate.age || issueCertificate.age === 0 || (typeof issueCertificate.age === 'string' && !issueCertificate.age)) {
        const dobValue = this.certficateForm.get('dob').value;
        if (dobValue) {
          issueCertificate.age = this.calculateAgeFromDob(dobValue);
        }
      }
      }

    if (issueCertificate.registrationNumber.trim().length == 0) {
      issueCertificate.registrationNumber = "New";
    }
    if (this.endorseRequest){
    const oldStatus = this.certificate.certificateStatus;
    this.certificateService.endorseRequestCertificate(issueCertificate)
      .pipe(first())
      .subscribe({
        next: (x) => {
          this.certificateResponse = new Certificate(x);
          this.certficateForm.controls['endorsementReason'].setValue(this.certificateResponse.endorsementReason);
          this.certficateForm.controls['endorsementCount'].setValue(this.certificateResponse.endorsementCount);
          this.startDateModel =  {"year":2010, "month": 1,"day": 1};

          if(this.certificateResponse.ageOrDob && this.certificateResponse.ageOrDob == "age")
    {
      this.startDateModel =  {"year":2010, "month": 1,"day": 1};
    }
    else
    {
          this.startDateModel.year = parseInt(this.certificateResponse.dob.split('-')[0]);
          this.startDateModel.day = parseInt(this.certificateResponse.dob.split('-')[2]);
          this.startDateModel.month = parseInt(this.certificateResponse.dob.split('-')[1]);
          }
          this.certficateForm.patchValue(this.certificateResponse);
          this.certficateForm.controls['dob'].setValue(this.startDateModel);
      
          // Update certificate cache with endorsed certificate
          this.certificateService.setCertificate(this.certificateResponse);
          
          // Update search results cache with complete certificate data and new status
          this.cacheService.trackStatusChange(
            this.certificate.id || '',
            this.certificate.certificateNumber,
            oldStatus,
            this.certificateResponse.certificateStatus
          );
          
          // Also update the complete certificate data in cache (for demographic changes)
          this.cacheService.updateCachedCertificateData(this.certificateResponse);

          // this.certificateCreated = true;

          this.alertService.success('Endorsement request created successfully', { keepAfterRouteChange: true });
          //introduce delay to allow the alert to show
          setTimeout(() => {
            this.loading = false;
            this.backToPrintCertificate();
          }, 3000);
          // this.onPdfClick();
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });
    }
    else {
    const oldStatus = this.certificate.certificateStatus;
    this.certificateService.editCertificate(issueCertificate)
    .pipe(first())
    .subscribe({
      next: (x) => {
        this.certificateResponse = new Certificate(x);
        this.certficateForm.controls['endorsementReason'].setValue(this.certificateResponse.endorsementReason);
        this.certficateForm.controls['endorsementCount'].setValue(this.certificateResponse.endorsementCount);
        this.startDateModel =  {"year":2010, "month": 1,"day": 1};
        if(this.certificateResponse.ageOrDob && this.certificateResponse.ageOrDob == "age")
    {
      this.startDateModel =  {"year":2010, "month": 1,"day": 1};
    }
    else
    {this.startDateModel.year = parseInt(this.certificateResponse.dob.split('-')[0]);
        this.startDateModel.day = parseInt(this.certificateResponse.dob.split('-')[2]);
        this.startDateModel.month = parseInt(this.certificateResponse.dob.split('-')[1]);
    }
        this.certficateForm.patchValue(this.certificateResponse);
        this.certficateForm.controls['dob'].setValue(this.startDateModel);
    
        // Update certificate cache with endorsed certificate
        this.certificateService.setCertificate(this.certificateResponse);
        
        // Update search results cache with complete certificate data and new status
        this.cacheService.trackStatusChange(
          this.certificate.id || '',
          this.certificate.certificateNumber,
          oldStatus,
          this.certificateResponse.certificateStatus
        );
        
        // Also update the complete certificate data in cache (for demographic changes)
        this.cacheService.updateCachedCertificateData(this.certificateResponse);
    
        this.certificateCreated = true;

        this.alertService.success('Endorsement request completed successfully', { keepAfterRouteChange: true });
        setTimeout(() => {
          this.loading = false;
          this.backToPrintCertificate();
        }, 3000);
      // this.onPdfClick();
      },
      error: error => {
        this.alertService.error(error);
        this.loading = false;
      }
    });

  }
    return;
  }
  convertTextDate(value: NgbDateStruct) {
    if (value) {
      this.dobString = value.year.toString();
      if (value.month < 10) {
        this.dobString = this.dobString + "-0" + value.month;
      }
      else {
        this.dobString = this.dobString + "-" + value.month;
      }
      if (value.day < 10) {
        this.dobString = this.dobString + "-0" + value.day;
      }
      else {
        this.dobString = this.dobString + "-" + value.day;
      }
    }
    return this.dobString;
  }
  calculateAgeFromDob(dob: string | NgbDateStruct): number {
    let birthDate: Date;
    
    if (typeof dob === 'string') {
      // If dob is a string in format "YYYY-MM-DD"
      const parts = dob.split('-');
      if (parts.length === 3) {
        birthDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
      } else {
        return 0;
      }
    } else if (dob && typeof dob === 'object' && 'year' in dob) {
      // If dob is an NgbDateStruct
      birthDate = new Date(dob.year, dob.month - 1, dob.day);
    } else {
      return 0;
    }
    
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    
    return Math.max(0, age);
  }
  onReset() {
    this.certificateCreated = false;
    this.submitted = false;
    this.alertService.clear();
    window.location.reload();
  }
  onPdfClick() {
    this.certificateService.PrintCertificate = this.certificateResponse;
    this.alertService.clear();
    this.router.navigate(['../printNew'], { relativeTo: null });
  }
  backToPrintCertificate(){
    // Navigate back to the previous route (the component that opened this one)
    this.location.back();
  }
  rejectEndorsementRequest(){
    if (this.rejectEndorsementForm.invalid) {
      return;
    }
    this.loading = true;
    const oldStatus = this.certificate.certificateStatus;
    
    let comment = this.rejectF.rejectComments.value;
    const requireAadhaar = this.rejectF.requireAadhaar.value;
    
    // If admin checked "require Aadhaar" checkbox, append it to the comment
    if (requireAadhaar) {
      comment += '\n[ADMIN REQUEST] Aadhaar card is required to complete this endorsement.';
    }
    
    const rejectCertificate = new Certificate({
      certificateNumber: this.certificate.certificateNumber,
      comment: comment,
      notificationEmail: this.rejectF.notificationEmail.value
    });
    
    this.certificateService.rejectEndorsementRequest(rejectCertificate)
      .pipe(first())
      .subscribe({
        next: (x) => {
          this.certificateResponse = new Certificate(x);
          
          // Update certificate cache with rejected certificate
          this.certificateService.setCertificate(this.certificateResponse);
          
          // Update search results cache with new status
          this.cacheService.trackStatusChange(
            this.certificate.id || '',
            this.certificate.certificateNumber,
            oldStatus,
            this.certificateResponse.certificateStatus
          );
          
          this.alertService.success('Endorsement request rejected successfully', { keepAfterRouteChange: true });
          // Close modal
          const modalElement = document.getElementById('rejectEndorsementModal');
          if (modalElement) {
            const modal = (window as any).bootstrap?.Modal?.getInstance(modalElement);
            if (modal) {
              modal.hide();
            }
          }
          setTimeout(() => {
            this.loading = false;
            this.backToPrintCertificate();
          }, 2000);
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });
  }
}
